import { useEffect, useState } from "react";
import { Alert } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Button } from "./Button.tsx";

export function AlertLogout({ click }) {
  const { t } = useTranslation();

  const [remaining, setRemaining] = useState(59);

  const decrementSeconds = () => setRemaining((prevSeconds) => prevSeconds - 1);

  useEffect(() => {
    const secondsInterval = setInterval(decrementSeconds, 1000);
    return () => {
      clearInterval(secondsInterval);
    };
  }, []);

  return (
    <Alert variant="info" className="global-alert text-center">
      <Alert.Heading>
        {t("LoggingOut", "Kirjaudutaan ulos {{remaining}} sekunnin kuluttua", { remaining })}
      </Alert.Heading>
      <Button testId="continue-using" variant="primary" onClick={click}>
        {t("ContinueUsing", "Jatka HR:n käyttöä")}
      </Button>
    </Alert>
  );
}
